/*
 * By Noth — puts the Instagram pill (same one as the footer) into the side menu.
 * The markup lives in <template id="bn-drawer-social"> (snippets/bynoth-drawer-social.liquid);
 * the theme's drawer snippet is too large to edit directly, so it is moved in here.
 */
(() => {
  const place = () => {
    const template = document.getElementById('bn-drawer-social');
    if (!template) return;
    document.querySelectorAll('.menu-drawer__utility-links').forEach((slot) => {
      if (slot.querySelector('.bn-drawer-social')) return;
      slot.appendChild(template.content.cloneNode(true));
    });
  };

  let frame = 0;
  const schedule = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(place);
  };

  document.addEventListener('DOMContentLoaded', () => {
    place();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  });
  document.addEventListener('shopify:section:load', schedule);
})();